import Alpine from "alpinejs";
import ajax from "@imacrayon/alpine-ajax";

window.Alpine = Alpine;

// Define imageModal as a global store
Alpine.store('imageModal', {
  show: false,
  imageUrl: '',
  openModal(url: string) {
    this.imageUrl = url;
    this.show = true;
    document.body.style.overflow = 'hidden'; // Prevent background scrolling when modal is open
  },
  closeModal() {
    this.show = false;
    this.imageUrl = ''; // Clear image URL on close
    document.body.style.overflow = ''; // Restore background scrolling
  }
});

Alpine.plugin(ajax);
Alpine.start();
